module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_3016.36ed5203.png";